<ion-row>
  <ion-col
    class="tab"
    *ngFor="let tab of tabs"
    [ngClass]="{ selected: tab.value === current }"
    (click)="handleTabChange(tab.value)"
    >{{ tab.label }}</ion-col
  >
</ion-row>
